(function() {
  var STORAGE_KEY = 'le_selected_location';
  var KARK_COOKIE = 'inventoryInfoApp';
  var WA_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" fill="#000"/></svg>';
  var PHONE_ICON = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.75 10.585v2.083a1.389 1.389 0 01-1.514 1.39 13.75 13.75 0 01-5.994-2.132 13.542 13.542 0 01-4.167-4.167A13.75 13.75 0 01.943 1.764 1.389 1.389 0 012.326.417H4.41a1.389 1.389 0 011.389 1.194c.088.66.25 1.308.486 1.93a1.389 1.389 0 01-.313 1.465L4.94 6.04a11.111 11.111 0 004.167 4.167l1.034-1.034a1.389 1.389 0 011.465-.312c.622.235 1.27.398 1.93.486a1.389 1.389 0 011.215 1.238z" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // Load locations from metaobjects JSON or fallback to hardcoded
  function getLocations() {
    var el = document.getElementById('le-sucursales-data');
    if (el) {
      try {
        var data = JSON.parse(el.textContent);
        if (data.length > 0) return data;
      } catch(e) {}
    }
    return [];
  }

  var LOCATIONS = getLocations();
  var trigger = document.getElementById('le-location-trigger');
  var modal = document.getElementById('le-loc-modal');
  if (!trigger || !modal) return;

  var stepCP = document.getElementById('le-loc-step-cp');
  var stepStores = document.getElementById('le-loc-step-stores');
  var cpInput = document.getElementById('le-loc-cp-input');
  var btnSearch = document.getElementById('le-loc-btn-search');
  var storesList = document.getElementById('le-loc-stores-list');

  function setKarkCookie(locationId) {
    document.cookie = KARK_COOKIE + '=' + JSON.stringify({locationId: parseInt(locationId)}) + '; path=/; max-age=31536000';
  }

  // Restore saved location — keep re-applying because theme re-renders header
  function restoreName() {
    var s = localStorage.getItem(STORAGE_KEY);
    if (!s) return;
    try {
      var d = JSON.parse(s);
      var el = document.getElementById('le-selected-store');
      if (el && d.name && el.textContent !== d.name) el.textContent = d.name;
      var elMobile = document.getElementById('le-selected-store-mobile');
      if (elMobile && d.name && elMobile.textContent !== d.name) elMobile.textContent = d.name;
    } catch(e) {}
  }
  restoreName();
  setInterval(restoreName, 500);

  // Mobile bar is now in sections/header.liquid — no JS move needed

  // Mobile trigger
  var triggerMobile = document.getElementById('le-location-trigger-mobile');
  if (triggerMobile) {
    triggerMobile.addEventListener('click', function() {
      stepCP.hidden = false;
      stepStores.hidden = true;
      if (cpInput) cpInput.value = '';
      modal.showModal();
    });
  }

  // Open modal
  trigger.addEventListener('click', function() {
    stepCP.hidden = false;
    stepStores.hidden = true;
    if (cpInput) cpInput.value = '';
    modal.showModal();
  });

  // Allow any element with [data-le-open-location-modal] to open the modal
  document.addEventListener('click', function(e) {
    var t = e.target.closest('[data-le-open-location-modal]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    stepCP.hidden = false;
    stepStores.hidden = true;
    if (cpInput) cpInput.value = '';
    modal.showModal();
  });

  // Close
  modal.addEventListener('click', function(e) {
    if (e.target.closest('.le-loc-modal__close')) modal.close();
    if (e.target === modal) modal.close();
  });

  // Haversine distance in km
  function getDistanceKm(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  // Show stores — sorted by geo distance or CP proximity
  function showStores(userLat, userLng) {
    var cpVal = cpInput ? cpInput.value.trim() : '';
    var cpNum = parseInt(cpVal) || 0;
    var useGeo = typeof userLat === 'number' && typeof userLng === 'number';

    var sorted = LOCATIONS.slice();

    if (useGeo) {
      // Add distance and sort by nearest
      sorted.forEach(function(s) {
        var sLat = parseFloat(s.lat);
        var sLng = parseFloat(s.lng);
        s._dist = (sLat && sLng) ? getDistanceKm(userLat, userLng, sLat, sLng) : 99999;
      });
      sorted.sort(function(a, b) { return a._dist - b._dist; });
    } else if (cpNum > 0) {
      sorted.sort(function(a, b) {
        var cpA = parseInt(a.cp) || 99999;
        var cpB = parseInt(b.cp) || 99999;
        return Math.abs(cpA - cpNum) - Math.abs(cpB - cpNum);
      });
    }

    var html = '';
    sorted.forEach(function(store) {
      var phoneNum = store.whatsapp || store.phone || '';
      var icon = store.whatsapp ? WA_ICON : PHONE_ICON;

      html += '<div class="le-loc-modal__store">' +
        '<label class="le-loc-modal__store-header">' +
          '<input type="radio" name="le-delivery" value="store-' + store.id + '" data-store-id="' + store.id + '" data-store-name="' + store.name + '">' +
          '<span class="le-loc-modal__store-name">' + store.name + '</span>' +
        '</label>';

      if (store.address || phoneNum || (useGeo && store._dist < 99999)) {
        html += '<div class="le-loc-modal__store-info">';
        if (store.address) {
          html += '<p class="le-loc-modal__store-address">' + store.address + '</p>';
        }
        if (useGeo && store._dist < 99999) {
          html += '<p class="le-loc-modal__store-distance">A ' + store._dist.toFixed(1) + ' km de tu ubicación</p>';
        }
        if (phoneNum) {
          html += '<span class="le-loc-modal__store-phone">' + icon + ' ' + phoneNum + '</span>';
        }
        html += '</div>';
      }

      html += '</div>';
    });

    if (!html) html = '<p style="font-size:13px;color:#666;">No se encontraron sucursales.</p>';

    storesList.innerHTML = html;
    stepCP.hidden = true;
    stepStores.hidden = false;

    // Mark saved
    var saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        var d = JSON.parse(saved);
        var r = storesList.querySelector('[data-store-id="' + d.id + '"]');
        if (r) r.checked = true;
      } catch(e) {}
    }

    // Selection handler
    storesList.querySelectorAll('input[type="radio"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        var name = this.getAttribute('data-store-name');
        var id = this.getAttribute('data-store-id');
        document.getElementById('le-selected-store').textContent = name;
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ id: id, name: name }));
        setKarkCookie(id);
        setTimeout(function() { modal.close(); window.location.reload(); }, 200);
      });
    });
  }

  if (btnSearch) btnSearch.addEventListener('click', function() { showStores(); });
  if (cpInput) cpInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') showStores(); });
  var noZipLink = modal.querySelector('.le-loc-modal__link');
  if (noZipLink) noZipLink.addEventListener('click', function() { showStores(); });

  // Geolocation — sort stores by distance from user
  var btnGeo = document.getElementById('le-loc-btn-geo');
  if (btnGeo && navigator.geolocation) {
    btnGeo.addEventListener('click', function() {
      btnGeo.disabled = true;
      btnGeo.textContent = 'Buscando ubicación...';

      navigator.geolocation.getCurrentPosition(function(pos) {
        var userLat = pos.coords.latitude;
        var userLng = pos.coords.longitude;
        showStores(userLat, userLng);
        btnGeo.disabled = false;
        btnGeo.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/></svg> Usar mi ubicación actual';
      }, function() {
        btnGeo.disabled = false;
        btnGeo.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/></svg> Usar mi ubicación actual';
        alert('No se pudo obtener tu ubicación. Verificá los permisos del navegador.');
      }, { timeout: 10000 });
    });
  } else if (btnGeo) {
    btnGeo.style.display = 'none';
  }

  // "Recibir en casa"
  modal.addEventListener('change', function(e) {
    if (e.target.value === 'domicilio') {
      document.getElementById('le-selected-store').textContent = 'Envío a Domicilio';
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ id: 'domicilio', name: 'Envío a Domicilio' }));
      setKarkCookie(-1);
      setTimeout(function() { modal.close(); window.location.reload(); }, 200);
    }
  });
})();
// v3
